import Vue from 'vue'
import Vuex from 'vuex'
import billing from './modules/billing'
import manager from './modules/manager'
import map from './modules/map'
import navi from './modules/navi'
import navi2 from './modules/navi2'
import realtime from './modules/realtime'
import units from './modules/units'
import grow from './modules/grow'
import caster from './modules/caster'
import auth from './modules/auth'
import pay from './modules/pay'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    manager: manager,
    navi: navi,
    navi2: navi2,
    map: map,
    units: units,
    billing: billing,
    realtime: realtime,
    grow: grow,
    caster: caster,
    auth: auth,
    pay: pay,
  },
})

export default store
